import * as collection from '../actions/updateSiteSetup.actions'
import {studySiteSetupState} from '../studysitewizard.state';


const initialstate:studySiteSetupState = {

   
    studySiteDetail : null
     
    }

export function reducer (state=initialstate,action:collection.Actions):studySiteSetupState
{
switch(action.type)
{

    case collection.update_SiteSetup:
    {
        var updatestate = initialstate;
       const productfilter = action.payload;
     if(productfilter != null){
        updatestate= Object.assign({},state,productfilter)} ;
    return state=updatestate;


}

case collection.update_SiteSetup_Success:

// case collection.Clear_SiteState:{

//     return state=initialstate;
// }

default:
{
    return state;
}

}
}